import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'
import { getSlug } from '@/core/utils.js'

export default class SilverBannerPodium extends HObject {
  static meshes = []
  static loadRequest = false
  constructor(hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
    this.inQueue = false
  }

  loadObject () {
    let hObject = this
    SilverBannerPodium.loadRequest = true
    BABYLON.SceneLoader.LoadAssetContainerAsync('static/assets/SilverBannerPodium/', 'SilverBannerPodium.babylon', window.scene).then(function (container) {
      for (let i = 0; i < container.meshes.length; i++) {
        container.meshes[i].isVisible = false
      }
      hObject.lod(container.meshes, 3000)
      container.addAllToScene()

      SilverBannerPodium.meshes = container.meshes
    })
  }

  register () {
    this.setupWidgets()
    this.loadContentImages()
    if (SilverBannerPodium.meshes.length) { // Se puede registrar el objeto puesto que ya se pueden crear instancias
      // Se marca que ya queda registrado, para que en un siguiente registro no se registre mas de una vez
      this.registered = true

      let newInstances = []

      for (let i = 0; i < SilverBannerPodium.meshes.length; i++) {

        // Crea clones para los mesh que se definen como widgets (porque no pueden compartir texturas)
        if (this.getIndexWidgetByMeshName(SilverBannerPodium.meshes[i].name) !== -1) {
          newInstances.push(SilverBannerPodium.meshes[i].clone(SilverBannerPodium.meshes[i].name))
          newInstances[newInstances.length - 1].isVisible = true
        }
        else { // Crea instancias para los que no requieren cambiar propiedades
          newInstances.push(SilverBannerPodium.meshes[i].createInstance(SilverBannerPodium.meshes[i].name))
        }
        //Asignando el padre correspondiente en newInstances según la misma relación en el arreglo original meshes
        if (SilverBannerPodium.meshes[i].parent !== undefined) {
          newInstances[i].parent = newInstances.find(mesh => mesh.name === SilverBannerPodium.meshes[i].parent.name)
        }
      }

      this.objectConfigurations(newInstances)

      this.afterloadSetup()
    } else {
      if (SilverBannerPodium.loadRequest === false) { // La primera vez que se desea registrar el objeto se debe cargar desde el servidor
        this.loadObject()
      }
      // Se agrega el objeto a la cola para reintentar posteriormente
      if (!this.inQueue) { // Se agrega sólo si aún no se ha agregado a la cola
        this.inQueue = true
        window.hScene.hObjectsRegisterQueue.push(this)
      }
    }
  }

  setupWidgets () {
    let monitor = {}
    monitor.meshName = 'banner'
    monitor.maxImages = 10
    this.addWidget(monitor)
  }

  afterloadSetup () {
    this.setContentFirstImages()
    this.widgetControls()

  }

  widgetControls () {

  }
}



// WEBPACK FOOTER //
// ./src/hobjects/SilverBannerPodium.js